export default "__VITE_ASSET__Cr_I6MXK__"